export const FormException = (event, message, div) => {
    console.error("Cannot Process due to following error : \n" + message );
    div.textContent = message;
    div.style.display = "block"
    div.classList.add("error");
    return null;
}
